// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RnrAssetManagerV2 from "../../view/assets/RnrAssetManagerV2.bs.js";

var video_icon = RnrAssetManagerV2.getImage("video-icon.svg");

var arrow_icon = RnrAssetManagerV2.getImage("arrow-icon.svg");

var porter_coin = RnrAssetManagerV2.getImage("porter-coin.svg");

var info_icon = RnrAssetManagerV2.getImage("info-icon.svg");

var close_icon = RnrAssetManagerV2.getImage("close-icon.svg");

var tooltip_icon = RnrAssetManagerV2.getImage("tooltip-icon.svg");

var back_arrow_icon = RnrAssetManagerV2.getImage("back-arrow-icon.svg");

var default_video_thumbnail = RnrAssetManagerV2.getImage("default-video-thumbnail.webp");

var play_button_icon = RnrAssetManagerV2.getImage("play-button.svg");

var white_arrow_icon = RnrAssetManagerV2.getImage("white-arrow-icon.svg");

var point_container_illustration = RnrAssetManagerV2.getImage("points-claim-illustration.svg");

var achieved_milestone_label_icon = RnrAssetManagerV2.getImage("achieved-milestone-label-icon.svg");

var unachieved_milestone_label_icon = RnrAssetManagerV2.getImage("unachieved-milestone-label-icon.svg");

var first_milestone_label_icon = RnrAssetManagerV2.getImage("first-milestone-label-icon.svg");

var verified_icon = RnrAssetManagerV2.getImage("verified-icon.svg");

var cross_icon = RnrAssetManagerV2.getImage("close-default.svg");

var login_hours_icon = RnrAssetManagerV2.getImage("login-hours-icon.svg");

var completed_orders_icon = RnrAssetManagerV2.getImage("completed-orders-icon.svg");

var order_rating_icon = RnrAssetManagerV2.getImage("order-rating-icon.svg");

var learn_more_video_thumbnail_1 = RnrAssetManagerV2.getImage("learn-more-video-thumbnail-1.webp");

export {
  video_icon ,
  arrow_icon ,
  porter_coin ,
  info_icon ,
  close_icon ,
  tooltip_icon ,
  back_arrow_icon ,
  default_video_thumbnail ,
  play_button_icon ,
  white_arrow_icon ,
  point_container_illustration ,
  achieved_milestone_label_icon ,
  unachieved_milestone_label_icon ,
  first_milestone_label_icon ,
  verified_icon ,
  cross_icon ,
  login_hours_icon ,
  completed_orders_icon ,
  order_rating_icon ,
  learn_more_video_thumbnail_1 ,
  
}
/* video_icon Not a pure module */
